export default "__VITE_ASSET__DJmDbIJ9__"